// Lógica espelhada em app/assets/javascripts/common.js#validateCnpj (mundo sprockets).
// Mantenha os dois sincronizados ao alterar regras de validação de CNPJ.
const FIRST_DIGIT_WEIGHTS = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
const SECOND_DIGIT_WEIGHTS = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

function calculateDigit(base, weights) {
  const sum = base.split('').reduce((acc, char, i) => (
    acc + (char.charCodeAt(0) - 48) * weights[i]
  ), 0);
  const remainder = sum % 11;
  return remainder < 2 ? 0 : 11 - remainder;
}

export function normalizeCNPJ(value) {
  if (!value) return '';
  return String(value).replace(/[^0-9A-Za-z]/g, '').toUpperCase();
}

export default function isValidCNPJ(value) {
  const cnpj = normalizeCNPJ(value);
  if (!/^[0-9A-Z]{12}\d{2}$/.test(cnpj)) return false;
  if (/^(\d)\1{13}$/.test(cnpj)) return false;

  const firstDigit = calculateDigit(cnpj.slice(0, 12), FIRST_DIGIT_WEIGHTS);
  const secondDigit = calculateDigit(cnpj.slice(0, 13), SECOND_DIGIT_WEIGHTS);

  return Number(cnpj[12]) === firstDigit && Number(cnpj[13]) === secondDigit;
}
